/* Sand of Scent - homepage behaviour.
   Three jobs only: reveal search, open the mobile drawer, and add to cart
   from a product card without leaving the page. No animation library,
   no carousel, no scroll listeners. */

(function () {
  'use strict';

  /* Sections include this file independently, so on a page carrying more
     than one of them the browser runs it more than once. Without this
     guard every listener is bound twice, which is invisible for handlers
     that set a state and fatal for handlers that toggle one: the search
     panel opened and closed again on a single click. */
  if (window.__sosHomeInit) return;
  window.__sosHomeInit = true;

  var $ = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------- search ---------- */

  function initSearch() {
    var toggle = $('[data-sos-search-toggle]');
    var panel = $('[data-sos-search]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) {
        var input = $('[data-sos-search-input]', panel);
        if (input) input.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-open') === 'true') {
        panel.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------- mobile drawer ---------- */

  function initDrawer() {
    var open = $('[data-sos-menu-open]');
    var close = $('[data-sos-menu-close]');
    var drawer = $('[data-sos-drawer]');
    if (!open || !drawer) return;

    function setOpen(state) {
      drawer.setAttribute('data-open', state ? 'true' : 'false');
      open.setAttribute('aria-expanded', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      showPanel(drawer, 'root', false);
      if (state) {
        var first = drawer.querySelector('a, button, summary');
        if (first) first.focus();
      } else {
        open.focus();
      }
    }

    open.addEventListener('click', function () {
      setOpen(true);
    });
    if (close) {
      close.addEventListener('click', function () {
        setOpen(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || drawer.getAttribute('data-open') !== 'true') return;
      // Escape steps back one level first, and only closes from the root
      var active = drawer.querySelector('.sos-drawer__panel.is-active');
      if (active && active.dataset.sosPanel !== 'root') showPanel(drawer, 'root', true);
      else setOpen(false);
    });

    /* parent items push a child panel in over the root */
    drawer.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-sos-panel-open]') : null;
      if (opener) {
        showPanel(drawer, opener.dataset.sosPanelOpen, true);
        return;
      }
      var back = e.target.closest ? e.target.closest('[data-sos-panel-back]') : null;
      if (back) showPanel(drawer, 'root', true);
    });
  }

  function showPanel(drawer, name, focusIt) {
    var panels = drawer.querySelectorAll('[data-sos-panel]');
    if (!panels.length) return;
    Array.prototype.forEach.call(panels, function (p) {
      var on = p.dataset.sosPanel === name;
      p.classList.toggle('is-active', on);
      if (on) {
        p.removeAttribute('aria-hidden');
        // a panel opened a second time should start at the top again
        p.scrollTop = 0;
      } else {
        p.setAttribute('aria-hidden', 'true');
      }
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-sos-panel-open]'), function (b) {
      b.setAttribute('aria-expanded', b.dataset.sosPanelOpen === name ? 'true' : 'false');
    });
    if (focusIt) {
      var active = drawer.querySelector('.sos-drawer__panel.is-active');
      var target = active && active.querySelector('[data-sos-panel-back], a, button');
      if (target) target.focus();
    }
  }

  /* ---------- shop tabs ---------- */

  function initTabs() {
    $$('[data-sos-tabs]').forEach(function (group) {
      var tabs = $$('[role="tab"]', group);
      if (!tabs.length) return;

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(tab);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) {
            e.preventDefault();
            select(next);
            next.focus();
          }
        });
      });
    });
  }

  /* ---------- add to cart from a card ---------- */

  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var el = $('[data-sos-cart-count]');
        if (!el) return;
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      })
      .catch(function () {});
  }

  /* The merchant can switch the cart drawer off in the theme editor. In page
     mode no drawer is rendered at all, so every add - ours, Dawn's quick-add
     on a collection card, the tester builder - ends on the cart page instead
     of silently doing nothing. */
  function cartMode() {
    var hdr = document.querySelector('[data-sos-cart-mode]');
    return (hdr && hdr.getAttribute('data-sos-cart-mode')) || 'drawer';
  }

  function cartUrl() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
  }

  function afterAdd() {
    if (window.SOSCart) return window.SOSCart.open();
    if (cartMode() === 'page') {
      window.location.href = cartUrl();
      return;
    }
    return refreshCartCount();
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sos-add]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-sos-add-label]');
      var original = label ? label.textContent : '';
      if (btn) btn.classList.add('is-busy');
      if (label) label.textContent = 'Lægger i kurv…';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(form.querySelector('input[name="id"]').value, 10),
              quantity: 1
            }
          ]
        })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            if (label) label.textContent = res.data && res.data.description ? 'Kunne ikke tilføjes' : 'Prøv igen';
            return;
          }
          if (label) label.textContent = 'Lagt i kurv';
          // the drawer refreshes the badge itself as it loads
          return afterAdd();
        })
        .catch(function () {
          if (label) label.textContent = 'Prøv igen';
        })
        .finally(function () {
          if (btn) btn.classList.remove('is-busy');
          setTimeout(function () {
            if (label) label.textContent = original;
          }, 2200);
        });
    });
  }

  /* ---------- review slider ---------- */

  function initSlider() {
    $$('[data-sos-slider]').forEach(function (track) {
      var root = track.closest('section') || document;
      var prev = root.querySelector('[data-sos-slide="prev"]');
      var next = root.querySelector('[data-sos-slide="next"]');
      if (!prev || !next) return;

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init() {
    initSlider();
    initSearch();
    initDrawer();
    initTabs();
    initAddToCart();
    initFooterCols();
    initSuggest();
    initRails();
    initHeroPicks();
    initCartDrawer();
    initCartBridge();
    initInfinite();
    initChatOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* The footer link columns are <details>. They collapse on a phone and are
     forced open from 750px up, so the desktop footer is unaffected. The
     state is only rewritten when the breakpoint is actually crossed, so a
     column the visitor opened is not slammed shut by an address-bar resize. */
  function initFooterCols() {
    var cols = document.querySelectorAll('[data-sos-foot-col]');
    if (!cols.length) return;
    var mq = window.matchMedia('(min-width: 750px)');

    function sync(e) {
      var wide = e.matches;
      Array.prototype.forEach.call(cols, function (d) {
        d.open = wide;
      });
    }

    sync(mq);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* ---------- predictive search ----------
     Shopify's /search/suggest.json, debounced, with the previous request
     aborted so a slow response can never overwrite a newer query. Results
     are products only: on a 316-product catalogue people search by brand
     or by bottle name, not for pages. Submitting still goes to /search,
     so the feature is additive and the form works with JS off. */

  function initSuggest() {
    var inputs = $$('[data-sos-suggest-input]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var scope = input.closest('[data-sos-search]') || input.closest('.sos-drawer') || document;
      var panel = scope.querySelector('[data-sos-suggest]');
      if (!panel) return;

      var timer = null;
      var controller = null;

      function close() {
        panel.setAttribute('hidden', '');
        panel.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      /* The suggest endpoint returns a bare decimal string ("349.00").
         Printed as-is it is the only price on the site without a currency
         or Danish separators, so it is formatted against the shop's own
         active currency rather than a hardcoded one. */
      function money(value) {
        if (value === null || value === undefined || value === '') return '';
        var num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
        if (isNaN(num)) return String(value);
        var cur =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
        try {
          return new Intl.NumberFormat('da-DK', {
            style: 'currency',
            currency: cur,
            minimumFractionDigits: 2
          }).format(num);
        } catch (e) {
          return num.toFixed(2).replace('.', ',') + ' kr';
        }
      }

      function render(q, products) {
        if (!products.length) {
          panel.innerHTML =
            '<p class="sos-sug__empty">Ingen match på “' + escapeHtml(q) + '”.</p>';
          panel.removeAttribute('hidden');
          input.setAttribute('aria-expanded', 'true');
          return;
        }

        var html = '<ul class="sos-sug__list" role="listbox">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          var brand = p.vendor || '';
          var name = p.title || '';
          if (brand) {
            // the catalogue repeats the brand at the head of most titles
            var dash = brand + ' - ';
            var ndash = brand + ' – ';
            if (name.indexOf(dash) === 0) name = name.slice(dash.length);
            else if (name.indexOf(ndash) === 0) name = name.slice(ndash.length);
            else if (name.indexOf(brand) === 0) name = name.slice(brand.length).replace(/^[\s\-–]+/, '');
          }
          html +=
            '<li role="option" aria-selected="false"><a class="sos-sug__row" href="' + p.url + '">' +
            (img
              ? '<span class="sos-sug__thumb"><img src="' + img + '&width=120" alt="" loading="lazy" width="48" height="60"></span>'
              : '<span class="sos-sug__thumb"></span>') +
            '<span class="sos-sug__text">' +
            (brand ? '<span class="sos-sug__brand">' + escapeHtml(brand) + '</span>' : '') +
            '<span class="sos-sug__name">' + escapeHtml(name) + '</span>' +
            '</span>' +
            '<span class="sos-sug__price">' + escapeHtml(money(p.price)) + '</span>' +
            '</a></li>';
        });
        html += '</ul>';
        html +=
          '<a class="sos-sug__all" href="/search?type=product&q=' +
          encodeURIComponent(q) +
          '">Se alle resultater for “' + escapeHtml(q) + '”</a>';

        panel.innerHTML = html;
        panel.removeAttribute('hidden');
        input.setAttribute('aria-expanded', 'true');
      }

      function query(q) {
        if (controller) controller.abort();
        controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

        var url =
          '/search/suggest.json?q=' +
          encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var products =
              (data.resources && data.resources.results && data.resources.results.products) || [];
            render(q, products);
          })
          .catch(function () {
            /* aborted or offline: leave whatever is on screen, never blank it */
          });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) {
          close();
          return;
        }
        timer = setTimeout(function () {
          query(q);
        }, 220);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var rows = panel.querySelectorAll('.sos-sug__row');
        if (!rows.length) return;
        e.preventDefault();
        var idx = -1;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] === document.activeElement) idx = i;
        }
        var next = e.key === 'ArrowDown' ? idx + 1 : idx - 1;
        if (next < 0) {
          input.focus();
          return;
        }
        if (next >= rows.length) next = rows.length - 1;
        rows[next].focus();
      });

      document.addEventListener('click', function (e) {
        if (!scope.contains(e.target)) close();
      });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- horizontal rails ----------
     Shared by any section with [data-sos-rail]. Scrolls by one tile plus
     its gap, measured from the DOM rather than assumed, and keeps the two
     arrows disabled at the ends so they never look broken. */

  function initRails() {
    $$('[data-sos-rail]').forEach(function (rail) {
      var scope = rail.closest('section') || document;
      var prev = scope.querySelector('[data-sos-rail-prev]');
      var next = scope.querySelector('[data-sos-rail-next]');
      if (!prev || !next) return;

      function step() {
        var first = rail.children[0];
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        var one = first.getBoundingClientRect().width + gap;
        // move a whole number of tiles, never leaving one half cut off
        var fit = Math.max(1, Math.floor(rail.clientWidth / one));
        return one * fit;
      }

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max - 2;
        var hidden = max <= 2;
        var arrows = scope.querySelector('[data-sos-rail-arrows]');
        if (arrows) arrows.style.visibility = hidden ? 'hidden' : '';
      }

      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- hero product picker ----------
     No autoplay: the visitor decides which bottle is shown. The buy card
     is filled from the active figure's own data attributes, which Liquid
     wrote from the live product, so nothing here is hardcoded. */

  function initHeroPicks() {
    var hero = $('[data-sos-hero]');
    if (!hero) return;

    var shots = $$('[data-sos-hero-shot]', hero);
    var picks = $$('[data-sos-hero-pick]', hero);
    if (!shots.length) return;

    var brandEl = $('[data-sos-hero-brand]', hero);
    var nameEl = $('[data-sos-hero-name]', hero);
    var priceEl = $('[data-sos-hero-price]', hero);
    var variantEl = $('[data-sos-hero-variant]', hero);
    var btn = hero.querySelector('.sos-hero__cardbtn');
    var label = $('[data-sos-add-label]', hero);

    function select(key) {
      var active = null;
      shots.forEach(function (fig) {
        var on = fig.dataset.sosHeroShot === String(key);
        fig.classList.toggle('is-active', on);
        if (on) {
          fig.removeAttribute('aria-hidden');
          active = fig;
        } else {
          fig.setAttribute('aria-hidden', 'true');
        }
      });
      picks.forEach(function (b) {
        var on = b.dataset.sosHeroPick === String(key);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!active) return;

      if (brandEl) brandEl.textContent = active.dataset.brand || '';
      if (nameEl) {
        nameEl.textContent = active.dataset.name || '';
        nameEl.setAttribute('href', active.dataset.url || '#');
      }
      if (priceEl) priceEl.textContent = active.dataset.price || '';
      if (variantEl) variantEl.value = active.dataset.variant || '';

      var sellable = active.dataset.available === 'true';
      if (btn) btn.disabled = !sellable;
      if (label) label.textContent = sellable ? 'Læg i kurv' : 'Udsolgt';
    }

    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        select(b.dataset.sosHeroPick);
      });
    });

    // fill the card from whichever figure Liquid marked active
    var first = hero.querySelector('.sos-hero__shot.is-active') || shots[0];
    if (first) select(first.dataset.sosHeroShot);
  }

  /* ---------- cart drawer ----------
     One drawer, fed by /cart.js, shared by every add-to-cart surface:
     product cards, the product page, the hero and the tester builder all
     call window.SOSCart.open(). Nothing about the cart is duplicated in
     Liquid, so the drawer and the cart page cannot drift apart.

     The cart icon stays a real link to /cart, so this is an enhancement:
     with JavaScript off, the link still works. */

  function initCartDrawer() {
    var root = $('[data-sos-cart]');
    if (!root) return;

    var body = $('[data-sos-cart-body]', root);
    var foot = $('[data-sos-cart-foot]', root);
    var totalEl = $('[data-sos-cart-total]', root);
    var titleCount = $('[data-sos-cart-title-count]', root);
    var ship = $('[data-sos-cart-ship]', root);
    var shipText = ship ? $('[data-sos-cart-ship-text]', ship) : null;
    var shipFill = ship ? $('[data-sos-cart-ship-fill]', ship) : null;
    var lastFocus = null;
    var busy = false;

    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
      try {
        return new Intl.NumberFormat('da-DK', {
          style: 'currency',
          currency: cur,
          minimumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
      }
    }

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function setOpen(state) {
      root.setAttribute('data-open', state ? 'true' : 'false');
      root.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) {
        lastFocus = document.activeElement;
        var first = root.querySelector('[data-sos-cart-close]');
        if (first) first.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    function renderShipping(cart) {
      if (!ship) return;
      var threshold = parseInt(ship.dataset.threshold, 10) || 0;
      if (!threshold || !cart.item_count) {
        ship.setAttribute('hidden', '');
        return;
      }
      ship.removeAttribute('hidden');
      var left = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      if (shipFill) shipFill.style.width = pct + '%';
      if (shipText) {
        shipText.innerHTML =
          left > 0
            ? 'Køb for <strong>' + money(left) + '</strong> mere og få fri fragt.'
            : 'Du har <strong>fri fragt</strong>.';
      }
      ship.classList.toggle('is-done', left <= 0);
    }

    function discountLines(item) {
      var all = item.line_level_discount_allocations || [];
      return all
        .filter(function (d) {
          return d && d.amount > 0;
        })
        .map(function (d) {
          return esc(d.discount_application.title) + ' −' + money(d.amount);
        })
        .join('<br>');
    }

    function render(cart) {
      if (titleCount) titleCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

      if (!cart.item_count) {
        body.innerHTML =
          '<div class="sos-cart__empty">' +
          '<p>Din kurv er tom.</p>' +
          '<a class="sos__btn sos__btn--ghost" href="/collections/all">Shop parfumer</a>' +
          '</div>';
        if (foot) foot.setAttribute('hidden', '');
        renderShipping(cart);
        return;
      }

      var html = '<ul class="sos-cart__list" role="list">';
      cart.items.forEach(function (item) {
        // the catalogue repeats the brand at the head of most titles
        var name = item.product_title || '';
        var brand = item.vendor || '';
        if (brand && name.indexOf(brand) === 0) {
          name = name.slice(brand.length).replace(/^[\s\-–]+/, '');
        }
        var variant =
          item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

        html +=
          '<li class="sos-cart__item" data-key="' + esc(item.key) + '">' +
          '<a class="sos-cart__thumb" href="' + esc(item.url) + '">' +
          (item.image
            ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) +
              '" alt="" width="64" height="80" loading="lazy">'
            : '') +
          '</a>' +
          '<div class="sos-cart__meta">' +
          (brand ? '<span class="sos-cart__brand">' + esc(brand) + '</span>' : '') +
          '<a class="sos-cart__name" href="' + esc(item.url) + '">' + esc(name) + '</a>' +
          (variant ? '<span class="sos-cart__variant">' + esc(variant) + '</span>' : '') +
          '<div class="sos-cart__row">' +
          '<span class="sos-cart__qty">' +
          '<button type="button" data-sos-cart-minus aria-label="Færre">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-sos-cart-plus aria-label="Flere">+</button>' +
          '</span>' +
          '<span class="sos-cart__line">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          // a real discount applied by Shopify, printed only when it is worth
          // money on this line: a BXGY allocates 0 to the line that did not
          // get the discount, and printing that reads as a broken offer
          (discountLines(item) ? '<span class="sos-cart__discount">' + discountLines(item) + '</span>' : '') +
          '</div>' +
          '<button type="button" class="sos-cart__remove" data-sos-cart-remove aria-label="Fjern">&times;</button>' +
          '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;

      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (foot) foot.removeAttribute('hidden');
      renderShipping(cart);
    }

    function syncBadges(cart) {
      document.querySelectorAll('[data-sos-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function load(openAfter) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          render(cart);
          syncBadges(cart);
          if (openAfter) setOpen(true);
          return cart;
        })
        .catch(function () {
          body.innerHTML = '<div class="sos-cart__empty"><p>Kurven kunne ikke hentes.</p></div>';
        });
    }

    function change(key, qty) {
      if (busy) return;
      busy = true;
      root.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          render(cart);
          syncBadges(cart);
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          root.classList.remove('is-busy');
        });
    }

    /* open from the cart icon, without losing the link for no-JS */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-sos-cart-open]') : null;
      if (opener) {
        e.preventDefault();
        load(true);
      }
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sos-cart-close]')) {
        setOpen(false);
        return;
      }
      var item = e.target.closest ? e.target.closest('[data-key]') : null;
      if (!item) return;
      var key = item.dataset.key;
      var qty = parseInt(item.querySelector('.sos-cart__qty span').textContent, 10) || 1;
      if (e.target.closest('[data-sos-cart-plus]')) change(key, qty + 1);
      else if (e.target.closest('[data-sos-cart-minus]')) change(key, qty - 1);
      else if (e.target.closest('[data-sos-cart-remove]')) change(key, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') setOpen(false);
    });

    window.SOSCart = {
      open: function () {
        return load(true);
      },
      refresh: function () {
        return load(false);
      },
      close: function () {
        setOpen(false);
      }
    };
  }

  /* ---------- legacy add-to-cart -> our drawer ----------
     Dawn's own product form still runs on the tester product template and
     on the collection quick-add buttons. Its drawer is hidden, so without
     this an add would give no feedback at all. Wrapping fetch catches
     every path that posts to /cart/add, including app code, rather than
     guessing at each form. */
  function initCartBridge() {
    if (!window.fetch || window.__sosCartBridge) return;
    window.__sosCartBridge = true;
    var orig = window.fetch;
    var last = 0;

    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var out = orig.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        out
          .then(function (res) {
            if (!res || !res.ok) return;
            var now = Date.now();
            if (now - last < 600) return; /* our own handlers already opened it */
            last = now;
            setTimeout(afterAdd, 0);
          })
          .catch(function () {});
      }
      return out;
    };
  }

  /* ---------- infinite scroll on collection pages ----------
     The server still renders ordinary paginated pages; this appends the
     next one as the visitor approaches the end of the grid. Everything is
     re-queried on each tick instead of being cached, because the filter
     form replaces the whole grid and its pagination when a facet changes.
     A manual button appears if a fetch fails, so the visitor is never
     stranded halfway down a collection. */
  function initInfinite() {
    if (!document.querySelector('[data-sos-inf]')) return;

    var busy = false;
    var fails = 0;

    function box() {
      return document.querySelector('[data-sos-inf]');
    }

    function grid() {
      return document.getElementById('product-grid');
    }

    function say(b, text) {
      var el = b.querySelector('[data-sos-inf-status]');
      if (el) el.textContent = text || '';
    }

    function counts(b) {
      var shown = grid() ? grid().querySelectorAll('.grid__item').length : 0;
      var total = parseInt(b.getAttribute('data-total'), 10) || 0;
      return { shown: shown, total: total };
    }

    function done(b) {
      var c = counts(b);
      b.setAttribute('data-done', 'true');
      b.removeAttribute('data-loading');
      say(b, c.total ? 'Du har set alle ' + c.total + ' produkter' : '');
      var more = b.querySelector('[data-sos-inf-more]');
      if (more) more.hidden = true;
    }

    function load() {
      var b = box();
      var g = grid();
      if (!b || !g || busy) return;
      var url = b.getAttribute('data-next');
      if (!url) {
        done(b);
        return;
      }

      busy = true;
      b.setAttribute('data-loading', 'true');
      var c = counts(b);
      say(b, c.total ? 'Indlæser flere produkter (' + c.shown + ' af ' + c.total + ')' : 'Indlæser flere produkter');

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelectorAll('#product-grid .grid__item');
          if (!incoming.length) {
            done(b);
            return;
          }

          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(incoming, function (li) {
            var node = document.importNode(li, true);
            /* the reveal animation only fires for items already in view
               when the observer ran, so appended cards must start visible */
            node.classList.remove('scroll-trigger', 'animate--slide-in');
            node.removeAttribute('data-cascade');
            node.removeAttribute('style');
            frag.appendChild(node);
          });
          g.appendChild(frag);

          var nextBox = doc.querySelector('[data-sos-inf]');
          var next = nextBox ? nextBox.getAttribute('data-next') : '';
          b.setAttribute('data-next', next || '');
          b.removeAttribute('data-loading');
          fails = 0;

          var after = counts(b);
          if (!next) {
            done(b);
          } else {
            say(b, after.total ? after.shown + ' af ' + after.total + ' produkter' : '');
          }
        })
        .catch(function () {
          b.removeAttribute('data-loading');
          fails += 1;
          say(b, 'Kunne ikke hente flere produkter.');
          var more = b.querySelector('[data-sos-inf-more]');
          if (more) more.hidden = false;
        })
        .then(function () {
          busy = false;
          /* the appended page may itself end above the fold on a tall screen */
          window.setTimeout(tick, 60);
        });
    }

    function tick() {
      var b = box();
      if (!b) return;
      if (!b.hasAttribute('data-js')) {
        b.setAttribute('data-js', 'true');
        var c = counts(b);
        if (c.total) say(b, c.shown + ' af ' + c.total + ' produkter');
      }
      if (busy || fails >= 2 || b.getAttribute('data-done') === 'true') return;
      if (!b.getAttribute('data-next')) {
        done(b);
        return;
      }
      var top = b.getBoundingClientRect().top;
      if (top - window.innerHeight < 900) load();
    }

    /* a timer rather than requestAnimationFrame: rAF is paused in a
       background tab, and a restored tab should already have its next page */
    var queued = 0;
    function onScroll() {
      if (queued) return;
      queued = window.setTimeout(function () {
        queued = 0;
        tick();
      }, 120);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-sos-inf-more]') : null;
      if (!btn) return;
      e.preventDefault();
      fails = 0;
      btn.hidden = true;
      load();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
  }

  /* ---------- Shopify Inbox chat launcher ----------
     The launcher is fixed to the bottom-left and sits on top of whatever is
     there - most visibly the sticky buy bar on a product page. Its shadow
     root is open, so the launcher is nudged up by exactly the height of a
     visible bottom bar. The widget's own stylesheet is adopted, which wins
     over any style element injected into the shadow root, so the offset is
     written to the element itself; it is re-applied on every pass in case
     the widget re-renders. Nothing about the widget is replaced, and if
     Shopify ever closes the shadow root this quietly does nothing. */
  function initChatOffset() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var node = launcher();
      if (node) {
        window.clearInterval(timer);
        start();
      } else if (tries > 40) {
        window.clearInterval(timer);
      }
    }, 500);

    function launcher() {
      try {
        var host = document.querySelector('shopify-chat');
        if (!host || !host.shadowRoot) return null;
        return host.shadowRoot.querySelector('.activator-nudge');
      } catch (e) {
        return null;
      }
    }

    function barHeight() {
      var bars = document.querySelectorAll('.sos-pdp__sticky.is-on, .otb__bar.is-live');
      var h = 0;
      Array.prototype.forEach.call(bars, function (bar) {
        var box = bar.getBoundingClientRect();
        if (box.height && box.bottom > window.innerHeight - 4) h = Math.max(h, box.height);
      });
      return h;
    }

    function start() {
      var applied = -1;

      var hiddenNow = null;

      function overlayOpen() {
        return !!document.querySelector(
          '[data-sos-cart][data-open="true"], [data-sos-drawer][data-open="true"], .sos-drawer[data-open="true"]'
        );
      }

      /* A price/buy box (the tester 5-pack, or anything marked
         data-sos-chat-avoid) is the one place the launcher must never sit on:
         while the two overlap, the launcher fades out and comes back as soon
         as the box scrolls past. */
      function coversBuyBox(node) {
        var r = node.getBoundingClientRect();
        if (!r.width) return false;
        var boxes = document.querySelectorAll('[data-sos-chat-avoid], .otp__buy');
        for (var i = 0; i < boxes.length; i++) {
          var b = boxes[i].getBoundingClientRect();
          if (b.width && r.left < b.right && r.right > b.left && r.top < b.bottom && r.bottom > b.top) return true;
        }
        return false;
      }

      function lift() {
        var node = launcher();
        if (!node) return;

        /* the launcher is above everything on the page, including our own
           cart drawer and menu, so it steps aside while one is open */
        var hide = overlayOpen() || coversBuyBox(node);
        if (hide !== hiddenNow) {
          hiddenNow = hide;
          node.style.setProperty('opacity', hide ? '0' : '1', 'important');
          node.style.setProperty('pointer-events', hide ? 'none' : 'auto', 'important');
        }

        /* On a phone the launcher is a wide "Chat" pill sitting on top of
           product cards and steppers. It keeps working as a round icon; the
           word goes. */
        var label = null;
        try {
          label = node.querySelector('.activator__label');
        } catch (e) {}
        if (label) {
          var narrow = window.innerWidth < 750;
          label.style.setProperty('display', narrow ? 'none' : '', narrow ? 'important' : '');
        }

        var h = barHeight();
        var bottom = h ? h + 12 + 20 : 20;
        if (bottom === applied) return;
        applied = bottom;
        node.style.setProperty('bottom', bottom + 'px', 'important');
        node.style.setProperty('transition', 'bottom .2s ease, opacity .15s ease', 'important');
      }

      lift();
      window.addEventListener('scroll', lift, { passive: true });
      window.addEventListener('resize', lift);
      window.setInterval(lift, 1500);
    }
  }

})();
